const FormInput = ({ label, ...props }) => (
  <div>
    <label className="block text-lg font-medium text-gray-700 mb-1">{label}</label>
    <input {...props} className="w-full px-3 py-2 border rounded" />
  </div>
);

export default FormInput;